import { useId, useState } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { ToggleGroup } from '@ui/kit';
import { SizeTransition } from '@utils/react';
import { useTaskContext } from '../../context.js';
import { DropzoneContainer } from './molecule.dropzones.js';
import { wrapper, toggle, transitionWrapper, crossfadeDurationMs, dropzoneContainer } from './organism.facit-container.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function FacitContainer(props) {
  const context = useTaskContext();
  const id = useId();
  const [tab, setTab] = useState("answer");
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    "data-tab": tab,
    "data-with-tabs": context === "facit",
    children: [context === "facit" && /*#__PURE__*/jsx("div", {
      className: toggle,
      children: /*#__PURE__*/jsx(ToggleGroup, {
        baseId: id,
        label: "V\xE6lg visningstilstand",
        onTabClick: setTab,
        selectedTabId: tab,
        tabs: [{
          id: "answer",
          title: "Mit svar"
        }, {
          id: "facit",
          title: "Rigtigt svar"
        }]
      })
    }), /*#__PURE__*/jsx(TransitionGroup, {
      component: "div",
      className: transitionWrapper,
      children: /*#__PURE__*/jsx(SizeTransition, {
        axis: "vertical",
        swappable: true,
        classNames: dropzoneContainer,
        timeout: crossfadeDurationMs,
        children: ref => /*#__PURE__*/jsx("div", {
          className: dropzoneContainer,
          ref: ref,
          children: /*#__PURE__*/jsx(DropzoneContainer, {
            taskEntryKey: props.taskEntryKey,
            dropzones: props.task.groups,
            tiles: props.task.content,
            facitType: tab === "facit" ? "should-have" : "user-entry"
          })
        })
      }, tab)
    })]
  });
}

export { FacitContainer };
//# sourceMappingURL=organism.facit-container.js.map
